export default __webpack_public_path__ + "static/media/pound.9dd51201.png";